import React from "react";
import PropTypes from "prop-types";
import {isSameDay} from "date-fns";
import {Button, Icon, Input, Toast} from "spectre-react/dist/cjs";
import {ABSENCE_REQUEST_KIND, DAY_STATUS} from "../../shared/constants";
import {dlyFmt, dmyFmt, isoFmt} from "../../shared/utils";
import {transformDayStatusToVacationKind} from "./shared";
import {submitAbsenceRequest} from "../../../api";


export default function withAbsenceRequestForm(WrapperComponent) {
    return class extends React.Component {
        static propTypes = {
            selectRange: PropTypes.bool,
            selectedRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
            selectedDay: PropTypes.instanceOf(Date),
            onRequestSubmitted: PropTypes.func,
            selectedEngineer: PropTypes.object.isRequired,
        }

        static defaultProps = {
            onRequestSubmitted: () => {},
        }

        state = {
            absenceFormOpened: false,
            absenceDayStatus: undefined,
            submitState: 0,
            submitError: null,
        }

        getAbsenceRange() {
            const {selectRange, selectedRange, selectedDay} = this.props;
            if (selectRange)
                return {startDate: selectedRange[0], endDate: selectedRange[1]};
            else
                return {startDate: selectedDay, endDate: selectedDay};
        }

        onSubmit = async (ev) => {
            ev.preventDefault();

            const form = ev.target;
            const comment = form.elements.comment.value;
            const {startDate, endDate} = this.getAbsenceRange();
            const data = {
                targetUserId: this.props.selectedEngineer._id,
                kind: transformDayStatusToVacationKind(this.state.absenceDayStatus),
                startDate: isoFmt(startDate),
                endDate: isoFmt(endDate),
                comment: comment
            }

            // это нужно лишь для того, чтобы в vacation можно было задетектить, что запись прилетела отсюда
            if (data.kind === ABSENCE_REQUEST_KIND.ILLNESS)
                data.comment = "Создано на s.signart.ru";

            this.setState({submitError: null, submitState: 1});

            try {
                await submitAbsenceRequest(data);

                this.setState({submitError: null, submitState: 2});

                setTimeout(() => {
                    this.doCloseForm();
                    this.props.onRequestSubmitted();
                }, 500);
            } catch (error) {
                this.setState({submitError: error.message, submitState: 0});
            }

        }

        doOpenForm = (absenceDayStatus) => this.setState({absenceDayStatus, absenceFormOpened: true});

        doCloseForm = () => this.setState({absenceDayStatus: undefined, absenceFormOpened: false, submitError: null, submitState: 0});

        renderEngineerText() {
            const {startDate, endDate} = this.getAbsenceRange();
            const absenceRangeText = isSameDay(startDate, endDate)
                ? <span><b>{dmyFmt(startDate)}</b></span>
                : <span>с <b>{dlyFmt(startDate)}</b> по <b>{dlyFmt(endDate)}</b> включительно</span>;

            const absenceDayStatus = this.state.absenceDayStatus;
            const absenceDescription = ((dayStatus) => {
                switch (dayStatus) {
                    case DAY_STATUS.TIME_OFF_UNPAID: return "неоплачиваемый отгул";
                    case DAY_STATUS.TIME_OFF_PAID: return "отгул";
                    case DAY_STATUS.VACATION_UNPAID: return "в отпуск за свой счет";
                    case DAY_STATUS.VACATION_PAID: return "в отпуск";
                    default: return `unknown absenceDayStatus=${dayStatus}`;
                }
            })(absenceDayStatus);

            if (absenceDayStatus === DAY_STATUS.TIME_OFF_UNPAID || absenceDayStatus === DAY_STATUS.TIME_OFF_PAID) {
                return <p>Нужен <b>{absenceDescription}</b> {absenceRangeText}</p>
            } else if (absenceDayStatus === DAY_STATUS.VACATION_UNPAID || absenceDayStatus === DAY_STATUS.VACATION_PAID) {
                return <div><p>Хочу <b>{absenceDescription}</b> {absenceRangeText}</p><p>Это та же самая форма, что и на vacation.signart.ru — сделано для удобства</p></div>
            } else if (absenceDayStatus === DAY_STATUS.ILLNESS) {
                return <p>Больничный {absenceRangeText}</p>
            }
        }

        renderManagementText() {
            const {startDate, endDate} = this.getAbsenceRange();
            const absenceRangeText = isSameDay(startDate, endDate)
                ? <span><b>{dmyFmt(startDate)}</b></span>
                : <span>с <b>{dlyFmt(startDate)}</b> по <b>{dlyFmt(endDate)}</b> включительно</span>;

            const absenceDayStatus = this.state.absenceDayStatus;
            const absenceDescription = ((dayStatus) => {
                switch (dayStatus) {
                    case DAY_STATUS.TIME_OFF_UNPAID: return "неоплачиваемый отгул";
                    case DAY_STATUS.TIME_OFF_PAID: return "отгул";
                    case DAY_STATUS.VACATION_UNPAID: return "отпуск за свой счет";
                    case DAY_STATUS.VACATION_PAID: return "отпуск";
                    case DAY_STATUS.ILLNESS: return "больничный";
                    default: return `unknown absenceDayStatus=${dayStatus}`;
                }
            })(absenceDayStatus);

            return (
                <div>
                    <div>Техник: {this.props.selectedEngineer._id}</div>
                    <div>Статус: {absenceDescription}</div>
                    <div>Период: {absenceRangeText}</div>
                </div>
            )
        }

        render() {
            const {onRequestSubmitted, ...props} = this.props;
            const {absenceFormOpened, submitState, submitError} = this.state;
            const isLoading = submitState === 1;

            if (!absenceFormOpened) {
                return <WrapperComponent doOpenAbsenceRequestForm={this.doOpenForm} {...props} />;
            }

            const currentUser = this.props.currentUser;

            return (
                <form onSubmit={this.onSubmit} id="absence-request-form">
                    <div className="form-group">
                        <Button block link onClick={this.doCloseForm}>
                            <Icon icon="arrow-left"/> Вернуться назад
                        </Button>
                    </div>
                    <div className="form-group">
                        {currentUser.isManagement && this.renderManagementText()}
                        {currentUser.isEngineer && !currentUser.isManagement && this.renderEngineerText()}
                    </div>
                    <div className="form-group">
                        <Input renderAs="textarea" rows="3" name="comment" defaultValue="" placeholder="Комментарий"/>
                    </div>
                    {submitError && (
                        <div className="form-group">
                            <Toast error>{submitError}</Toast>
                        </div>
                    )}
                    <div className="form-group">
                        <Button type="submit" block primary loading={isLoading}>Отправить заявку</Button>
                    </div>
                </form>
            )
        }
    }
}